<fuse-loading-bar></fuse-loading-bar>

<!-- Sabit Sidebar - Sadece sidebar modu seçiliyken görünür veya yukarıda iken her zaman -->
<fuse-vertical-navigation [class.dark]="true" class="backdrop-blur-md bg-black/40 print:hidden"
    *ngIf="!isMenuPopup || (backgroundService.navBarPosition | async) === 'top'"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="!isScreenSmall" [inner]="false">


    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>

        <div class="flex items-center w-full p-2">

            <div class="flex items-center ml-auto">
                <user-profile [showAvatar]="false"></user-profile>
            </div>

        </div>

        <div class="flex flex-col items-center w-full mb-4">

            <div class="w-36 h-36 rounded-lg bg-white/60 flex items-center justify-center">
                <app-navizard-logo [usePreset]="true" [isLight]="false" [logoType]="'v1'"></app-navizard-logo>
            </div>

            <div class="flex flex-col items-center justify-center w-full mt-2">

                <div
                    class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-center leading-normal font-mediu">
                    {{displayName}}
                </div>
                <div
                    class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium ">
                    {{userName}}
                </div>

            </div>

        </div>
    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>

        <div class="flex flex-0 items-center justify-center h-64 pr-6 pl-2 mt-2 mb-4 opacity-12">

            <app-navizard-logo class="w-36 h-36" [usePreset]="true" [isLight]="true"
                [logoType]="'v1'"></app-navizard-logo>
        </div>

    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>

        <div
            class="p-2 text-xs text-center justify-center font-semibold text-gray-600 dark:text-gray-300 bg-transparent">
            <app-navizard-versioning></app-navizard-versioning>
        </div>
    </ng-container>

</fuse-vertical-navigation>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 overflow-hidden relative">

    <div class="absolute inset-0 safe-area">
        <app-debug-badge [isDebugMode]="globals.isDebugMode" [badgeColor]="'#000000'">
            <a [routerLink]="['settings']" fragment="Performance-Browser-EnableDebug">
                <div class="flex flex-col items-center">
                    <fa-icon [icon]="['fal', 'seedling']" size="lg" class="text-green-500"></fa-icon>
                    <span class="text-sm font-bold text-yellow-500">Platform 2.0</span>
                    <span class="text-xs  ">Technology Preview </span>
                </div>
            </a>
        </app-debug-badge>

        <!-- Sayfa karartma overlay'i - dock hover durumunda aktifleşir -->
        <div class="dark-overlay " [class.active]="isDockActive"></div>

        <!-- MacOS tarzı dock alan ve hover bölgesi -->
        <div class="dock-area" *ngIf="(backgroundService.navBarPosition | async) === 'bottom'"
            (mouseenter)="isHovering = true; activateDock()" (mouseleave)="isHovering = false; deactivateDock()">
            <!-- MacOS tarzı dock - otomatik gizlenen -->
            <div class="frosty dock-auto-hide flex items-center h-[72px] px-8 z-[999] print:hidden pointer-events-auto"
                [class.active]="isDockActive" [class.no-auto-hide]="!isDockAutoHide">
                <!-- MacOS tarzı dock menü -->
                <div class=" flex items-center space-x-2 mx-4">
                    <!-- Ana Uygulamalar Grubu -->
                    <div class=" flex items-center space-x-2">
                        <frost-overlay-menu [buttonMode]="true" [triggerIcon]="['fal', 'home']"
                            [triggerIconColor]="'text-gray-700'" [useRoundButtons]="true" [routeLink]="'/dashboard'">
                        </frost-overlay-menu>

                        <frost-overlay-menu [buttonMode]="true" [triggerIcon]="['fal', 'map-marked']"
                            [triggerIconColor]="'text-gray-700'" [useRoundButtons]="true" [routeLink]="'/live'">
                        </frost-overlay-menu>

                   
                    </div>

                    <!-- Dikey Ayırıcı -->
                    <div class="h-8 w-px bg-slate-100/80 mx-1"></div>

                    <!-- Araçlar ve Grafikler Grubu -->
                    <div class=" flex items-center space-x-2">
                        <!-- Reports Popup Menu Button -->
                        <frost-overlay-menu [darkTheme]="true" [minWidth]="'320px'" [menuTitle]="'Raporlar'"
                            [menuDescription]="'Sistem raporları'" [menuItems]="reportsFrostMenuItems"
                            [triggerIcon]="['fal', 'chart-bar']" [triggerIconColor]="'text-gray-700'" [position]="'top'"
                            [useRoundButtons]="true" (menuItemSelected)="onFrostMenuItemClick($event)">
                        </frost-overlay-menu>

                        <!-- External Apps Popup Menu Button -->
                        <frost-overlay-menu [darkTheme]="true"  [minWidth]="'320px'"[menuTitle]="'Harici Uygulamalar'"
                            [menuDescription]="'Entegre edilmiş harici uygulamalar'"
                            [menuItems]="externalAppsFrostMenuItems" [triggerIcon]="['fal', 'window-restore']"
                            [triggerIconColor]="'text-indigo-500'" [position]="'top'" [useRoundButtons]="true"
                            [showArrow]="true" (menuItemSelected)="onFrostMenuItemClick($event)">
                        </frost-overlay-menu>


                    </div>

                    <!-- Boşluk - Esnek dolgu alanı -->
                    <div class="flex-grow"></div>

                    <!-- Bildirimler Grubu -->
                    <div class=" flex items-center space-x-2">
                        <frost-overlay-menu *ngrxLet="(notificationData$ | async)?.unreadMessages as unreadCount"
                            [buttonMode]="true" [triggerIcon]="[unreadCount > 0 ? 'fas' : 'fal', 'bell']"
                            [triggerIconColor]="'text-gray-700'" [useRoundButtons]="true"
                            [routeLink]="'/notifications'">
                            <!-- Sadece unreadCount 0'dan büyükse sayıyı göster -->
                            <ng-container *ngIf="unreadCount > 0">
                                <span class="absolute top-0 right-0 flex items-center justify-center">
                                    <span
                                        class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 rounded-full bg-red-500 z-10 text-indigo-50 text-xs font-medium">
                                        {{ unreadCount }}
                                    </span>
                                </span>
                            </ng-container>
                        </frost-overlay-menu>
                    </div>
                </div>

                <!-- Dikey Ayırıcı -->
                <div class="h-8 w-px bg-slate-100/80 mx-1"></div>

                <!-- Sağ taraftaki kontroller -->
                <div class=" flex items-center space-x-2">
                    <!-- User Popup Menu Button - FrostOverlayMenu ile değiştirildi -->
                    <frost-overlay-menu [menuTitle]="displayName" [menuDescription]="userName"
                        [menuItems]="userMenuItems" [triggerIcon]="['fal', 'user']" [triggerIconColor]="'text-gray-700'"
                        [position]="'top'" [useRoundButtons]="true" [backdropBlur]="true"
                        (menuItemSelected)="onFrostMenuItemClick($event)">

                        <!-- Özel header template kullanımı - Avatar ve kullanıcı bilgileri -->
                        <ng-template #menuHeader>
                            <div class="flex flex-col items-center p-4 bg-gradient-to-b from-sky-100 to-white">
                                <div
                                    class="w-16 h-16 rounded-full overflow-hidden border-2 border-white shadow-md mb-2">
                                    <img [src]="avatar || 'assets/images/avatars/default.jpg'" alt="User avatar"
                                        class="w-full h-full object-cover" (error)="errorHandler($event)">
                                </div>
                                <div class="text-center">
                                    <h3 class="text-gray-800 font-medium">{{displayName}}</h3>
                                    <p class="text-gray-500 text-sm">{{userName}}</p>
                                </div>
                            </div>
                        </ng-template>

                        <!-- Özel footer template kullanımı - Çıkış butonu -->
                        <ng-template #menuFooter>
                            <div class="p-2 border-t border-gray-200">
                                <button mat-button
                                    class="w-full flex items-center justify-center space-x-2 text-red-500 hover:bg-red-50 rounded-lg p-2"
                                    (click)="logout()">
                                    <fa-icon [icon]="['fal', 'sign-out-alt']"></fa-icon>
                                    <span>{{ 'SystemAdmin.Common.Profile.SignOut' | translate }}</span>
                                </button>
                            </div>
                        </ng-template>
                    </frost-overlay-menu>

                    <!-- Dock Settings Animated Menu Button -->
                    <frost-overlay-menu #settingsMenu [minWidth]="'400px'" [buttonMode]="false"
                        [menuTitle]="'SystemAdmin.Layout.Dock.Settings.Title' | translate"
                        [menuDescription]="'SystemAdmin.Layout.Dock.Settings.Description' | translate"
                        [triggerIcon]="['fal', 'cogs']" [triggerIconColor]="'text-gray-700'" [useRoundButtons]="true"
                        [backdropBlur]="true" >

                        <!-- Özel menü içeriği template'i - Tailwind ile geniş ve açıklamalı ayarlar -->
                        <ng-template #menuContent>

                            <!-- Tek sütunlu kompakt düzen -->
                            <!-- Menü Stili Ayarı -->
                            <div
                                class="p-3 rounded-lg bg-gray-100/30 border border-gray-200/80 transition-colors hover:bg-gray-100/70 dark:bg-gray-700/30 dark:border-gray-600/80 dark:hover:bg-gray-700/70">
                                <div class="flex items-center justify-between">
                                    <div class="flex-grow">
                                        <div class="flex items-center">
                                            <fa-icon [icon]="['fal', isMenuPopup ? 'window-restore' : 'sidebar']"
                                                class="text-gray-600 dark:text-gray-300 mr-3 text-lg"></fa-icon>
                                            <div>
                                                <div class="text-base font-medium text-gray-700 dark:text-gray-200">
                                                    {{ 'SystemAdmin.Layout.Dock.Settings.MenuStyle' | translate }}</div>
                                                <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                                    {{ isMenuPopup ? ('SystemAdmin.Layout.Dock.Settings.MenuStylePopup'
                                                    | translate)
                                                    :
                                                    ('SystemAdmin.Layout.Dock.Settings.MenuStyleSidebar' | translate) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <app-toggle-switch [(ngModel)]="menuStyleValue"
                                            (ngModelChange)="toggleSetting('menu-style', $event)"
                                            [onIcon]="['fal', 'sidebar']" [offIcon]="['fal', 'window-restore']">
                                        </app-toggle-switch>
                                    </div>
                                </div>
                            </div>

                            <!-- Otomatik Gizleme Ayarı -->
                            <div
                                class="p-3 rounded-lg bg-gray-100/30 border border-gray-200/80 transition-colors hover:bg-gray-100/70 dark:bg-gray-700/30 dark:border-gray-600/80 dark:hover:bg-gray-700/70">
                                <div class="flex items-center justify-between">
                                    <div class="flex-grow">
                                        <div class="flex items-center">
                                            <fa-icon [icon]="['fal', isDockAutoHide ? 'eye-slash' : 'eye']"
                                                class="text-gray-600 dark:text-gray-300 mr-3 text-lg"></fa-icon>
                                            <div>
                                                <div class="text-base font-medium text-gray-700 dark:text-gray-200">
                                                    {{ 'SystemAdmin.Layout.Dock.Settings.AutoHide' | translate }}</div>
                                                <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                                    {{ isDockAutoHide ?
                                                    ('SystemAdmin.Layout.Dock.Settings.AutoHideEnabled' |
                                                    translate)
                                                    : ('SystemAdmin.Layout.Dock.Settings.AutoHideDisabled' | translate)
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <app-toggle-switch [(ngModel)]="isDockAutoHide"
                                            (ngModelChange)="toggleSetting('auto-hide', $event)"
                                            [onIcon]="['fal', 'check']" [offIcon]="['fal', 'times']">
                                        </app-toggle-switch>
                                    </div>
                                </div>
                            </div>

                            <!-- Tam Ekran Modu Ayarı -->
                            <div
                                class="p-3 rounded-lg bg-gray-100/30 border border-gray-200/80 transition-colors hover:bg-gray-100/70 dark:bg-gray-700/30 dark:border-gray-600/80 dark:hover:bg-gray-700/70">
                                <div class="flex items-center justify-between">
                                    <div class="flex-grow">
                                        <div class="flex items-center">
                                            <fa-icon [icon]="['fal', 'expand']"
                                                class="text-gray-600 dark:text-gray-300 mr-3 text-lg"></fa-icon>
                                            <div>
                                                <div class="text-base font-medium text-gray-700 dark:text-gray-200">
                                                    {{ 'SystemAdmin.Layout.Dock.Settings.Fullscreen' | translate }}
                                                </div>
                                                <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                                    {{ isFullscreen ?
                                                    ('SystemAdmin.Layout.Dock.Settings.FullscreenEnabled' |
                                                    translate) :
                                                    ('SystemAdmin.Layout.Dock.Settings.FullscreenDisabled' | translate)
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <app-toggle-switch [(ngModel)]="isFullscreen"
                                            (ngModelChange)="toggleSetting('fullscreen', $event)" [onIcon]="['fal', 'compress']"
                                            [offIcon]="['fal', 'expand']">
                                        </app-toggle-switch>
                                    </div>
                                </div>
                            </div>

                            <!-- Dock Pozisyonu Ayarı -->
                            <div
                                class="mb-3 p-3 rounded-lg bg-gray-100/30 border border-gray-200/80 transition-colors hover:bg-gray-100/70 dark:bg-gray-700/30 dark:border-gray-600/80 dark:hover:bg-gray-700/70">
                                <div class="flex items-center justify-between">
                                    <div class="flex-grow">
                                        <div class="flex items-center">
                                            <fa-icon [icon]="['fal', isDockAtTop ? 'arrow-down' : 'arrow-up']"
                                                class="text-gray-600 dark:text-gray-300 mr-3 text-lg"></fa-icon>
                                            <div>
                                                <div class="text-base font-medium text-gray-700 dark:text-gray-200">
                                                    {{ 'SystemAdmin.Layout.Dock.Settings.Position' | translate }}</div>
                                                <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                                    {{ isDockAtTop ? ('SystemAdmin.Layout.Dock.Settings.PositionTop' |
                                                    translate) :
                                                    ('SystemAdmin.Layout.Dock.Settings.PositionBottom' | translate) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <app-toggle-switch [(ngModel)]="isDockAtTop"
                                            (ngModelChange)="toggleSetting('dock-position', $event)"
                                            [onIcon]="['fal', 'arrow-up']" [offIcon]="['fal', 'arrow-down']">
                                        </app-toggle-switch>
                                    </div>
                                </div>
                            </div>

                            <!-- Separator -->
                            <hr class="my-3 border-gray-200 dark:border-gray-600">

                            <!-- Arkaplan Değiştirme -->
                            <div
                                class="mb-3 p-3 rounded-lg bg-gray-100/30 border border-gray-200/80 transition-colors hover:bg-gray-100/70 dark:bg-gray-700/30 dark:border-gray-600/80 dark:hover:bg-gray-700/70">
                                <div class="flex items-center justify-between">
                                    <div class="flex-grow">
                                        <div class="flex items-center">
                                            <fa-icon [icon]="['fal', 'image']"
                                                class="text-gray-600 dark:text-gray-300 mr-3 text-lg"></fa-icon>
                                            <div>
                                                <div class="text-base font-medium text-gray-700 dark:text-gray-200">
                                                    Arkaplan Değiştir</div>
                                                <div class="text-sm text-gray-500 dark:text-gray-400 mt-1">
                                                    Farklı arkaplan resimleri arasında geçiş yap
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <button (click)="backgroundService.setBackground(); $event.stopPropagation();" 
                                            class="h-9 w-9 flex items-center justify-center rounded-full bg-blue-100 hover:bg-blue-200 text-blue-700">
                                            <fa-icon [icon]="['fal', 'image']"></fa-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </ng-template>
                    </frost-overlay-menu>

                    <!-- Dil seçimi ve fullscreen butonları -->
                    <frost-overlay-menu [menuTitle]="'SystemAdmin.Common.Language.Title' | translate"
                        [menuDescription]="'SystemAdmin.Common.Language.Description' | translate"
                        [menuItems]="languageMenuItems" [triggerIcon]="['fal', 'language']"
                        [triggerIconColor]="'text-gray-700'" [position]="'top'" [useRoundButtons]="true"
                        (menuItemSelected)="onFrostMenuItemClick($event)">
                    </frost-overlay-menu>

                    <!-- Fullscreen butonu dock settings menüsüne taşındı -->
                </div>

                <!-- Görünmez algılama alanı - fare dock altında dolaşırken hover'ı korur -->
                <div class="dock-hit-area pointer-events-auto"></div>
            </div>
        </div>

        <!-- Standart üst bar (yukarıdayken dock stili olmaz) -->
        <div class="frosty flex items-center h-16 px-1 z-[999] print:hidden ml-3 mr-3 mx-auto absolute pointer-events-auto"
            *ngIf="(backgroundService.navBarPosition | async) === 'top'" [ngClass]="{
                'mt-3 inset-0 top-0': true
            }">
            <!-- Hamburger butonu - menü tipine göre farklı davranır -->
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <fa-icon [icon]="['fal', 'bars']" class="text-2xl"></fa-icon>
            </button>
            <!-- Components -->
            <div class="flex-grow"></div> <!-- Bu div sol taraftaki boşluğu dolduracak -->
            <div class="flex flex-col items-center space-y-1">

                <div *ngIf="!(networkStatusService.isOnline | async)"
                    class="text-center bg-white/70 ring-2 ring-white/10 border-none border-white/20 text-red-600 p-2 rounded-md  px-12 py-3 sm:py-1">
                    <div class="text-md text-red-500 ">
                        {{ 'SystemAdmin.Common.Network.Offline' | translate }}
                    </div>
                    <div class="text-sm text-red-500 hidden sm:block">
                        {{ 'SystemAdmin.Common.Network.OfflineDescription' | translate }}
                    </div>
                </div>

            </div>
            <div class="flex-grow"></div> <!-- Bu div sağ taraftaki boşluğu dolduracak -->
            <div class="flex items-center space-x-0.5 sm:space-x-2">

                <button mat-icon-button *ngrxLet="(notificationData$ | async)?.unreadMessages as unreadCount"
                    #notificationsOrigin routerLinkActive routerLink="/notifications"
                    [matTooltip]="'SystemAdmin.Notifications.Title' | translate">
                    <ng-container>
                        <!-- Sadece unreadCount 0'dan büyükse sayıyı göster -->
                        <span *ngIf="unreadCount > 0"
                            class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
                            <span
                                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-red-500 z-10 text-indigo-50 text-xs font-medium">
                                {{ unreadCount }}
                            </span>
                        </span>
                    </ng-container>
                    <!-- Zil ikonu her zaman görünür, ama yalnızca unreadCount 0'dan büyükse sallanır -->
                    <fa-icon [icon]="[unreadCount > 0?'fas':'fal', 'bell']" [class.fa-shake]="unreadCount > 0"
                        class="block z-0" size="lg" style="--fa-animation-duration: 4s;"></fa-icon>
                </button>

                <button mat-icon-button (click)="backgroundService.setBackground()" [matTooltip]="'Live Tracking'">
                    <fa-icon [icon]="['fal' , 'image']" size="lg"></fa-icon>
                </button>

                <!-- Menü stili toggle butonu - Sadece menu aşağıdayken göster -->
                <button mat-icon-button (click)="toggleMenuStyle()"
                    *ngIf="(backgroundService.navBarPosition | async) === 'bottom'"
                    class="hover:bg-white/10 transition-all hover:scale-110 rounded-full"
                    [matTooltip]="isMenuPopup ? 'Sidebar Görünümüne Geç' : 'Popup Görünümüne Geç'">
                    <fa-icon [icon]="['fal', isMenuPopup ? 'window-restore' : 'sidebar']" size="lg"></fa-icon>
                </button>

                <!-- Dock pozisyonu toggle butonu - üst bar için -->
                <button mat-icon-button (click)="toggleDockPosition()"
                    [matTooltip]="((backgroundService.navBarPosition | async) === 'bottom') ? 'Bar\'ı Üste Taşı' : 'Bar\'ı Alta Taşı'">
                    <fa-icon
                        [icon]="['fal', ((backgroundService.navBarPosition | async) === 'bottom') ? 'arrow-up' : 'arrow-down']"
                        size="lg"></fa-icon>
                </button>

                <button mat-icon-button #shortcutsOrigin routerLinkActive routerLink="/live"
                    [matTooltip]="'Live Tracking'">
                    <fa-icon [icon]="['fal' , 'map-marked']" size="lg"></fa-icon>
                </button>


                <languages></languages>
                <!-- Fullscreen butonu dock settings menüsüne taşındı -->


            </div>
        </div>
    </div>

    <!-- Navigation - Popup modu için ve menu toggle açıldığında görünür -->
    <fuse-vertical-navigation #mainNavigation [class.dark]="true" [class.sidebar-mode]="!isMenuPopup"
        class="backdrop-blur-md bg-black/90 print:hidden shadow-xl fixed h-auto min-h-auto max-h-[80vh] rounded-xl overflow-hidden z-[999]"
        [ngClass]="{
            'bottom-16 top-auto transform -translate-x-1/2 translate-y-full left-1/2 w-[350px] min-w-[350px] max-w-[350px]': (backgroundService.navBarPosition | async) === 'bottom' && !navigationOpened && isMenuPopup,
            'bottom-16 top-auto transform -translate-x-1/2 translate-y-0 left-1/2 w-[350px] min-w-[350px] max-w-[350px]': (backgroundService.navBarPosition | async) === 'bottom' && navigationOpened && isMenuPopup,
            'top-16 bottom-auto transform -translate-x-1/2 -translate-y-full left-1/2 w-[350px] min-w-[350px] max-w-[350px]': (backgroundService.navBarPosition | async) === 'top' && !navigationOpened && isMenuPopup,
            'top-16 bottom-auto transform -translate-x-1/2 translate-y-0 left-1/2 w-[350px] min-w-[350px] max-w-[350px]': (backgroundService.navBarPosition | async) === 'top' && navigationOpened && isMenuPopup,

            'hidden': !isMenuPopup || (backgroundService.navBarPosition | async) === 'top',
            'bottom-0 top-0 left-0 transform-none w-[280px] min-w-[280px] max-w-[280px] translate-x-[-280px]': !isMenuPopup && !navigationOpened,
            'bottom-0 top-0 left-0 transform-none w-[280px] min-w-[280px] max-w-[280px] translate-x-0': !isMenuPopup && navigationOpened
        }" [mode]="isMenuPopup ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
        [opened]="navigationOpened" [inner]="false" [transparentOverlay]="true" [autoCollapse]="isMenuPopup">

        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>

            <div class="flex items-center w-full p-2">

                <div class="flex items-center ml-auto">
                    <user-profile [showAvatar]="false"></user-profile>
                </div>

            </div>

            <div class="flex flex-col items-center w-full mb-4">

                <div class="w-36 h-36 rounded-lg bg-white/60 flex items-center justify-center">
                    <app-navizard-logo [usePreset]="true" [isLight]="false" [logoType]="'v1'"></app-navizard-logo>
                </div>

                <div class="flex flex-col items-center justify-center w-full mt-2">

                    <div
                        class="w-full whitespace-nowrap overflow-ellipsis overflow-hidden text-center leading-normal font-mediu">
                        {{displayName}}
                    </div>
                    <div
                        class="w-full mt-0.5 whitespace-nowrap overflow-ellipsis overflow-hidden text-center text-md leading-normal font-medium ">
                        {{userName}}
                    </div>

                </div>

            </div>
        </ng-container>
    </fuse-vertical-navigation>

    <!-- Content -->
    <div class="absolute inset-0 overflow-y-auto overflow-x-hidden">
        <div class="">
            <div class="w-full h-screen">

                <router-outlet> </router-outlet>

            </div>
        </div>

    </div>

</div>

<!-- Eski menü konteynerleri silindi -->